import React from 'react';
import { Link } from 'react-router-dom';

class ManageSubscriptionHeader extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div>
        <div className="manage-account-header-body pl-sm-4">
          <div className="title-bar-without-breadcrumbs mr-0 ml-0 row">
            <div className="title-text-large">
              <Link
                to="/app/account-settings"
                key="ac-settings-link"
                className="br-link"
              >
                <i className="icon-chevron_left" /> ACCOUNT SETTINGS
              </Link>
              Manage My Subscription
            </div>
          </div>
        </div>
        <div className="gradient-divider" />
      </div>
    );
  }
}

export default ManageSubscriptionHeader;
